// toastr.service.ts
import { Injectable } from '@angular/core';
import { ToastrService as NgxToastr } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  constructor(private toastr: NgxToastr) {}

  success(message: string, title?: string) {
    this.toastr.success(message, title);
  }

  error(message: string, title?: string) {
    this.toastr.error(message, title);
  }

  info(message: string, title?: string) {
    this.toastr.info(message, title);
  }

  warning(message: string, title?: string) {
    this.toastr.warning(message, title);
  }
}
